import { Button, ButtonProps, SxProps, Typography } from '@mui/material';
import React from 'react';

interface IProps extends ButtonProps {
  children: string | React.ReactNode;
  textColor?: string;
  rootStyle?: SxProps;
  typoStyle?: SxProps;
}
export default function LinkButton(props: IProps) {
  return (
    <Button
      sx={{
        backgroundColor: 'transparent',
        '& :hover': { backgroundColor: 'transparent' },
        ...props.rootStyle,
      }}
      variant="text"
      {...props}
    >
      <Typography
        variant="linkText"
        sx={{
          color: props.textColor ? props.textColor : 'secondary.main',
          ...props.typoStyle,
        }}
      >
        {props.children}
      </Typography>
    </Button>
  );
}
